/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SwatchSelectorMinimal_item = {
    readonly isMultiSku: boolean;
    readonly variableAttributes: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly variableAttributeData: {
            readonly swatchSort: ReadonlyArray<{
                readonly swatch: {
                    readonly serviceId: string | null;
                    readonly displayName: string | null;
                    readonly imageUrl: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "SwatchSelectorMinimal_item";
};
export type SwatchSelectorMinimal_item$data = SwatchSelectorMinimal_item;
export type SwatchSelectorMinimal_item$key = {
    readonly " $data"?: SwatchSelectorMinimal_item$data;
    readonly " $fragmentRefs": FragmentRefs<"SwatchSelectorMinimal_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SwatchSelectorMinimal_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isMultiSku",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "variableAttributes",
      "storageKey": null,
      "args": null,
      "concreteType": "VariableAttribute",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "variableAttributeData",
          "storageKey": null,
          "args": null,
          "concreteType": "VariableAttributeSortType",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "swatchSort",
              "storageKey": null,
              "args": null,
              "concreteType": "SwatchSort",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "swatch",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Swatch",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "displayName",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "imageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'afbae8226322c466b45a405b5aa8d2e4';
export default node;
